import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FilePickerAdapter, FilePickerComponent, FilePreviewModel } from '@anaidenko/ngx-awesome-uploader';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent implements OnInit {
  @ViewChild(FilePickerComponent, { static: false })
  picker!: FilePickerComponent;

  @Input()
  adapter!: FilePickerAdapter;

  @Output()
  fileAdded = new EventEmitter<FilePreviewModel>();

  @Output()
  uploaded = new EventEmitter<FilePreviewModel>();

  @Output()
  uploadFailed = new EventEmitter<HttpErrorResponse>();

  constructor() { }

  ngOnInit(): void {
  }

  public onFileAdded(event: FilePreviewModel): void {
    this.fileAdded.emit(event);
  }

  public onUploadSuccess(event: FilePreviewModel): void {
    this.uploaded.emit(event);
  }

  public onUploadFail(event: HttpErrorResponse): void {
    this.uploadFailed.emit(event);
  }

  public removeFiles() {
    this.picker.files.forEach(file => {
      this.picker.removeFile(file);
    });
  }
}
